export default {
  responsible: 'Responsable',
  reviewModalTitle: 'Évaluation du projet',
  evaluateProject: 'Évaluer le projet',
  yourRecruiter: 'Votre recruteur',
  review: 'Évaluation',
  myReview: 'Mon évaluation',
  comment: 'Commentaire',
  frelancerReviewed: 'Pigiste évalué',
  recruiterAndAlliancesReviewed: 'Recruteur et Alliances évalués',
  recruiterAndAlliancesNotified: 'Le Recruteur et vos Alliances seront nofitiés.',
  commentPlaceholder: 'Laisser un commentaire...',
  reviewAlreadySubmitted: 'Vous avez déjà évalué {{name}} pour ce projet.',
  rateRequired: 'Veuillez donner une évaluation.',
  bidder: 'Pigiste soumissionnaire',
  successfulRating: 'Votre évaluation de {{name}} a été bien enregistrée',
  evaluation: 'évaluation',
  from: 'de',
  noReviews: 'Aucune évaluation trouvée',
  loadMoreReviews: "Charger plus d'évaluations",
  review_counts_one: '{{count}} évaluation',
  review_counts_plural: '{{count}} évaluations',
  cancel_review: 'Annuler l’évaluation',
  cancel_review_hint:
    'Êtes-vous sûr de vouloir annuler cette évaluation ? Elle ne sera plus visible',
  cancel_and_confirm: 'Annuler et confirmer',
  validate_review: 'Valider l’évaluation',
  validate_review_hint:
    'Êtes-vous sûr de vouloir valider cette évaluation ? Cela la rendra publique.',
  update_review_status: 'Mettre à jour le statut de l’évaluation',
  has_reviewed: 'a évalué',
  approve_review: 'Approuver',
};
